import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=168a0180&scoped=true&"
import script from "./reviewDetail.vue?vue&type=script&lang=js&"
export * from "./reviewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a0180",
  null
  
)

export default component.exports